<template>
  <section data-testid="contact-section">
    <div class="bg">
      <div class="mx-auto flex w-full max-w-7xl flex-col justify-center gap-4 px-4 py-20 md:h-[426px] md:w-4/5 md:flex-row md:items-center md:p-0">
        <div class="flex h-52 flex-col justify-center gap-4 bg-white md:h-48 md:w-1/2">
          <p class="text-center text-xs leading-6 tracking-tight text-black2 md:mx-4 md:text-sm md:leading-7">
            Please contact us for any questions or requests <br class="md:hidden" />about our activities or service. <br />We will get in touch with you shortly.
          </p>
          <div class="mx-auto lg:w-80">
            <AtomsSecondaryButton class="mx-auto w-full" font-mode="en" :on-click="props.onClickContact">Contact us</AtomsSecondaryButton>
          </div>
        </div>
        <div class="flex h-52 flex-col justify-center gap-4 bg-white md:h-48 md:w-1/2">
          <p class="text-center text-xs leading-6 tracking-tight text-black2 md:mx-4 md:text-sm md:leading-7">
            Sign up to receive email updated on <br />new experiences, stories, <br class="md:hidden" />special promotions and more.
          </p>
          <div class="mx-auto lg:w-80">
            <AtomsSecondaryButton class="mx-auto w-full" font-mode="en" :on-click="props.onClickPartner">Partner with us</AtomsSecondaryButton>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
interface Props {
  onClickContact: () => void;
  onClickPartner: () => void;
}

const props = defineProps<Props>();
</script>

<style scoped lang="scss">
.bg {
  background-image: url('/img/bg/en-contact-bg-sp.jpg');

  @media screen and (min-width: 600px) {
    background-image: url('/img/bg/en-contact-bg.jpg');
  }
}
</style>
